<!-- 添加新电表选择设备弹窗 -->
<template>
  <div class="addNewMeterDialogBody">
    <el-dialog title="添加电表" :visible.sync="dialogFormVisible">
      <div style="display: flex;width: 90%;">
        <div class="dialog-device">
          <elCheckBoxTree :dataList="deviceDataList" @checkItem="checkItemList"></elCheckBoxTree>
        </div>
        <div class="dialog-from">
          <el-form :model="form">
            <el-form-item label="表类型" :label-width="formLabelWidth" :required="nonEmpty">
              <el-select v-model="form.meterRunType" placeholder="请选择" style="height: 30px;width: 100%;" disabled>
                <el-option v-for="item in SetMeterType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="结算类型" :label-width="formLabelWidth" :required="nonEmpty">
              <el-select v-model="form.accountType" placeholder="请选择" style="height: 30px;width: 100%;" disabled>
                <el-option v-for="item in SettlementType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="基本电费分摊值" :label-width="formLabelWidth" :required="nonEmpty">
              <el-input v-model="form.basicElectricityCharges" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="每月赠送电度" :label-width="formLabelWidth" :required="nonEmpty">
              <el-input v-model="form.freeQuota" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item v-show="form.accountType==0" label="缴费日期(日)" :label-width="formLabelWidth"
              :required="nonEmpty">
              <el-select v-model="form.deductionFeeDay" placeholder="请选择" style="height: 30px;width: 100%;">
                <el-option v-for="item in dateList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item v-if="form.meterRunType!=1 || form.accountType!=1" label="计费方式" :label-width="formLabelWidth"
              :required="nonEmpty" style="height: 30px;width: 100%;">
              <el-cascader style="width: 100%;" v-model="form.BillingMethod" :options="billingMethodList"
                disabled></el-cascader>
            </el-form-item>
            <el-form-item label="绑定的设备" :label-width="formLabelWidth" :required="nonEmpty">
              <el-input v-model="form.deviceNameList" :disabled='true' placeholder="请在左边选择设备"
                autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import meterManagerStore from '../meterManagerStore.js'
  import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
  export default {
    components: {
      elCheckBoxTree,
    },
    props: {},
    data () {
      return {
        //新增的
        dialogFormVisible: false,
        nonEmpty: true,
        formLabelWidth: "150px",
        meterType: "electric",
        form: {
          accountType: 1, //结算类型
          meterRunType: 2,//电表类型
          basicElectricityCharges: 0, //基本电费分摊
          deductionFeeDay: 1, //缴费日期
          BillingMethod: [], //计费方式
          deviceNameList: '', //绑定的设备
          freeQuota: 0 //每月免费电度
        },
        deviceNos: '',
      }
    },
    computed: {
      SettlementType () {
        return [{
          label: '后付费',
          value: 0
        },{
          label: '预付费',
          value: 1
        }]
      },

      SetMeterType () {
        return [{
          label: '预付费电表',
          value: 1
        },{
          label: '远控表',
          value: 2
        }]
      },

      billingMethodList () {
        // debugger
        this.form.BillingMethod=['SingleBilling',this.allChargeMode.SingleBilling[0]!=null? this.allChargeMode.SingleBilling[0].id:null]
        return [{
          label: '单价计费',
          value: 'SingleBilling',
          children: this.cascaderList(this.allChargeMode.SingleBilling)
        },{
          label: '阶梯计费',
          value: 'StepBilling',
          children: this.cascaderList(this.allChargeMode.StepBilling)
        },{
          label: '费率计费',
          value: 'PeakAndValleyBilling',
          children: this.cascaderList(this.allChargeMode.PeakAndValleyBilling)
        }]
      },
      allChargeMode () {
        return meterManagerStore.state.allChargeMode
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      dateList () {
        var list=[]
        for(var i=1;i<32;i++) {
          list.push({
            label: i+'号',
            value: i
          })
        }
        return list
      },
      deviceDataList () {
        // 尚未被配置为抄表的设备筛选
        var tree=this.$store.deviceStore.getters.getControlDeviceTree
        // var tree = this.$store.deviceStore.getters.getReadDeviceTree
        console.log("电表",tree);
        var nos=this.meterList.map(item => item.id)
        let list=filterTreeRecursive([copy(tree)],item => {
          return !(item.entityName=="VirtualDevicePojo"&&nos.includes(item.id))
        })
        // console.log("deviceList(list)",deviceList(list));
        return deviceList(list)
      },
      meterList () {
        return meterManagerStore.state.meterList
      },
    },
    watch: {},
    mounted () {
      this.getDefaultParams()
    },
    methods: {
      confirm () {
        //非空处理
        if(isempty(this.deviceNos)) {
          this.$message.error("请选择设备")
          return
        }
        //确认添加
        this.$api.meterReadingApi.saveMeterReadingConfig(this.deviceNos,this.form.BillingMethod[1],
          this.form.deductionFeeDay,this.form.basicElectricityCharges,this.form.accountType,this.form.meterRunType,this.meterType,
          this.form.freeQuota,respon => {
            this.$message.success('添加电表成功！')
            meterManagerStore.commit('getMeterReadingConfigList',this.nowUnit.id)
            this.$emit("successList")
          },err => {
            this.$message.error(err)
          })
        this.dialogFormVisible=false
      },
      checkItemList (list) {
        //debugger
        this.form.deviceNameList=''
        this.deviceNos=''
        list.forEach((item,i) => {
          if(item.type=='virtualDevice') {
            if(i+1<list.length) {
              this.form.deviceNameList+=item.label+','
              this.deviceNos+=item.no+','
            } else {
              this.form.deviceNameList+=item.label
              this.deviceNos+=item.no
            }
          }
        })
      },
      cascaderList (list) {
        //debugger
        if(list!=null) {
          let elementList=JSON.parse(JSON.stringify(list).replace(/id/g,"value"))
          elementList=JSON.parse(JSON.stringify(elementList).replace(/name/g,"label"))
          return elementList
        }
      },
      // 获取单位的默认参数
      getDefaultParams () {
        this.$api.meterReadingApi.getBaseMeterDefault(this.nowUnit.id,respon => {
          if(!isempty(respon)) {
            this.deductionFeeDay=respon.deductionFeeDay
          }
        },err => {
          this.$dialogMethod.showMessage(err)
        })
      },
    }
  }
</script>
<style>
  .addNewMeterDialogBody .dialog-from {
    /*width: calc(100% - 3.3rem);*/
    height: 50%;
  }

  .addNewMeterDialogBody .el-dialog__body {
    display: flex;
    align-items: center;
    padding: 0;
  }

  .addNewMeterDialogBody .el-dialog {
    width: 40%;
  }

  .addNewMeterDialogBody .dialog-device {
    height: 500px;
    margin-left: 40px;
  }

  .addNewMeterDialogBody .elCheckBoxTreeBody {
    padding-bottom: 20px;
  }
</style>